import LivingRoomExperience from "@inter-ikea-range/living-room-experience";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experiences
export const livingRoomExperience = (settings: EnvironmentSettings) =>
  LivingRoomExperience(settings);

// range packages
export const livingRoomPackages = (_settings: EnvironmentSettings): Experience[] => [];
